


import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const CustomPagination = ({ 
  totalItems, 
  itemsPerPage, 
  currentPage, 
  onPageChange 
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const isDisabled = totalItems === 0 || totalPages === 0;

  const handlePageClick = (page) => {
    if (!isDisabled && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const createPageItem = (i) => (
    <li
      key={i}
      className={`page-item ${i === currentPage ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
    >
      <a
        className={`page-link ${!isDisabled ? '_avPointer' : ''}`}
        onClick={() => handlePageClick(i)}
      >
        {i}
      </a>
    </li>
  );

  let pages = [];

  if (!isDisabled && totalPages > 0) {
    // First page
    pages.push(createPageItem(1));

    // Dots before
    const rangeStart = Math.max(2, currentPage - 2);
    if (rangeStart > 2) {
      pages.push(
        <li key="dots-before" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Middle pages
    const rangeEnd = Math.min(totalPages - 1, currentPage + 2);
    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(createPageItem(i));
    }

    // Dots after
    if (rangeEnd < totalPages - 1) {
      pages.push(
        <li key="dots-after" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Last page
    if (totalPages > 1) {
      pages.push(createPageItem(totalPages));
    }
  }

  return (
    <div className="pagination-container">
      <style>{`
        .pagination-container {
          display: flex;
          justify-content: center;
          // margin: 20px 0;
        }
        
        .pagination {
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
          gap: 4px;
        }
        
        .page-item {
          display: inline-block;
        }
        
        .page-link {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 36px;
          height: 26px;
          padding: 8px 12px;
          border: 1px solid #dee2e6;
          background-color: #fff;
          color: #007bff;
          text-decoration: none;
          border-radius: 4px;
          transition: all 0.3s;
        }
        
        .page-link._avPointer {
          cursor: pointer;
        }
        
        .page-link._avPointer:hover {
          background-color: #e9ecef;
          border-color: #dee2e6;
        }
        
        .page-item.active .page-link {
          background-color: #007bff;
          border-color: #007bff;
          color: #fff;
          cursor: default;
        }
        
        .page-item.disabled .page-link {
          color: #6c757d;
          background-color: #fff;
          border-color: #dee2e6;
          cursor: not-allowed;
          opacity: 0.5;
        }
        
        .page-item.disabled .page-link:hover {
          background-color: #fff;
        }
      `}</style>

      <ul className="pagination">
        {/* Previous Button */}
        <li
          className={`page-item ${
            currentPage === 1 || isDisabled ? 'disabled' : ''
          }`}
        >
          <a
            className={`page-link ${currentPage > 1 && !isDisabled ? '_avPointer' : ''}`}
            onClick={() => handlePageClick(currentPage - 1)}
          >
            <ChevronLeft size={18} />
          </a>
        </li>

        {pages}

        {/* Next Button */}
        <li
          className={`page-item ${
            currentPage === totalPages || isDisabled ? 'disabled' : ''
          }`}
        >
          <a
            className={`page-link ${currentPage < totalPages && !isDisabled ? '_avPointer' : ''}`}
            onClick={() => handlePageClick(currentPage + 1)}
          >
            <ChevronRight size={18} />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default CustomPagination;
